'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconScreenCheckLines, iconScreenCheckLinesTag } from '@ni/nimble-components/dist/esm/icons/screen-check-lines';
import { wrap } from '../../utilities/react-wrapper';

export type { IconScreenCheckLines };
export { iconScreenCheckLinesTag };
export const NimbleIconScreenCheckLines = wrap(IconScreenCheckLines);